function triggerHeaderScroll() {
  // The element we will observe.
  const header = document.querySelector(".header");

  // Observer options.
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0,
  };

  // Callback function executed during observe.
  const callback = function (entries, observer) {
    // Target the first entry available.
    let observedHeader = entries[0];

    // Add or remove the blur.
    !observedHeader.isIntersecting
      ? document.body.classList.add("scrolled")
      : document.body.classList.remove("scrolled");
  };

  // Construct Intersection Observer.
  const observer = new IntersectionObserver(callback, options);

  // Observe if element is present.
  if (header) {
    observer.observe(header);
  }
}

export { triggerHeaderScroll };
